import { INDEX_TITLE, PRODUCTS_INDEX_ROUTE } from './consts';

export default () => ({
    label: INDEX_TITLE,
    link: PRODUCTS_INDEX_ROUTE,
    icon: 'stock',
    permission: 'products.index',
    order: 20,
});
